<template>
  <a class="button back-to-top is-large" @click="backToTop()" v-show="visible">
    <span class="icon is-small">
      <i class="fas fa-arrow-alt-circle-up fa-lg" style="color: #ffdd57;"></i>
    </span>
  </a>
</template>

<script>
export default {
  name: "BackToTop",
  props: {},
  data() {
    return {
      visible: false
    };
  },
  methods: {
    catchScroll() {
      this.visible = window.pageYOffset > 600;
    },
    backToTop: function() {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.backToTop);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    }
  },
  mounted: function() {
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  }
};
</script>

<style scoped>
a.back-to-top {
  display: block;
  bottom: 20px;
  right: 30px;
  position: fixed;
  z-index: 99;
}
</style>
